require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-the-weekend-australian-mansion-magazine-luxe-life.json") })
        }
      }, "path---journal-the-weekend-australian-mansion-magazine-luxe-life");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-the-weekend-australian-mansion-magazine-luxe-life!./.cache/json/journal-the-weekend-australian-mansion-magazine-luxe-life.json
// module id = 544
// module chunks = 231608221292675